@if (isLoadingAccessoryFilters) {
  <app-spinner />
} @else {
  <form [formGroup]="filterForm">
    <div class="accessory-filters">
      @if (!accessoryFilters) {
        <app-spinner />
      } @else {
        <div class="accessory-form-group main-categories">
          <button
            class="main-category-btn"
            data-ignore-lint
            [ngClass]="{ active: isActiveCategory(MainCategories.All) }"
            (click)="onMainCategoryChange(MainCategories.All)"
          >
            {{ MainCategories.All }}
          </button>
          @for (mainCategory of accessoryFilters.mainCategories; track mainCategory; let i = $index) {
            <button
              class="main-category-btn"
              data-ignore-lint
              [ngClass]="{ active: isActiveCategory(mainCategory) }"
              (click)="onMainCategoryChange(mainCategory)"
            >
              {{ mainCategory }}
            </button>
          }
        </div>

        <div class="accessory-form-group">
          <div class="filter-title">Tilgjengelig for</div>
          <div class="filter-options">
            <mat-checkbox formControlName="onlyDisplayEligibleForAccessoryBinding">
              <span class="filter-checkbox-text">Tilbehørsbinding</span>
            </mat-checkbox>
          </div>
        </div>

        @if (activeMainCategory === MainCategories.PhoneAccessory) {
          <div class="accessory-form-group">
            <div class="filter-title">Type tilbehør</div>
            <div class="filter-options">
              @for (item of allSubCategories; track item.value; let i = $index) {
                <ng-container formArrayName="subCategories">
                  <div [formGroupName]="i">
                    <mat-checkbox formControlName="isSelected">
                      <span class="filter-checkbox-text">
                        {{ item.controls.name.value }}
                      </span>
                    </mat-checkbox>
                  </div>
                </ng-container>
              }
            </div>
          </div>
        }

        <div class="accessory-form-group">
          <div class="filter-title">Merke</div>
          <div class="filter-options">
            @for (item of allManufacturers; track item.value; let i = $index) {
              <ng-container formArrayName="manufacturers">
                <div [formGroupName]="i">
                  <mat-checkbox formControlName="isSelected">
                    <span class="filter-checkbox-text">
                      {{ item.controls.name.value }}
                    </span>
                  </mat-checkbox>
                </div>
              </ng-container>
            }
          </div>
        </div>
      }
    </div>
  </form>
}
